import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import {
  Autocomplete,
  Checkbox,
  FormControl,
  Grid,
  TextField,
} from '@mui/material';

import { GridSizeType, gridSize } from '@/shared';
import { Control, Controller, FieldError } from 'react-hook-form';

export type AcutocompletePromocionProps<T> = {
  options: T[];
  defaultValue?: T[];

  valueKey: keyof T;
  actualValueKey?: keyof T;

  loadingText?: string;
  isLoadingData: boolean;

  optionLabelForEdit?: string;

  // form
  control: Control<any, any>;
  label: string;
  name: string;
  disabled?: boolean;
  onChangeValue?: (value: string) => void;
  onChangeRawValue?: (value: T[]) => void;
  error: FieldError | undefined | boolean;
  helperText: React.ReactNode;
  required?: boolean;
  textFieldKey: string;

  size?: GridSizeType;

  limitTags?: number;
  getOptionDisabled?: boolean;
  workingRawData?: boolean;
  useSpecificKey?: boolean;
  specificKey?: keyof T;
  value?: any[]
};

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
// AcutocompletePromocion
export default function AcutocompletePromocion<T>({
  options,
  valueKey,
  // actualValueKey,

  isLoadingData,
  loadingText = 'Cargando...',

  // form
  // optionLabelForEdit,
  value,
  label,
  name,
  control,
  defaultValue,
  error,
  helperText,
  required = true,
  disabled = false,
  onChangeRawValue,
  onChangeValue,
  textFieldKey,

  size = gridSize,

  limitTags = 2,
  getOptionDisabled = false,
  workingRawData = false,
  useSpecificKey = true,
  specificKey,
}: AcutocompletePromocionProps<T>) {
  return (
    <>
      <Grid item {...size}>
        <FormControl fullWidth>
          <Controller
            name={name}
            control={control}
            key={textFieldKey}
            defaultValue={defaultValue}
            // render
            render={({ field }) => {
              const onChange = (_event: any, data: T[]) => {
                // work with raw data
                if (workingRawData) return field.onChange(data);
                
                //en el caso de que haya una specificKey se guarda el valor de esa key en el array
                if (useSpecificKey && specificKey) {
                  const selectedValue: any =
                  data.map((d: any) => d[specificKey]) || '[]';
                  field.onChange(selectedValue);
                  
                  onChangeValue && onChangeValue(selectedValue); // string
                  console.log(data)
                  onChangeRawValue && onChangeRawValue(data); // T[]
                  return;
                }else{
                  onChangeRawValue && onChangeRawValue(data); // T[]
                  return
                }
                
               /*  // data is an valid array
                const isThereAnyValue = !!data?.length;
                const selectedValue: string = isThereAnyValue
                  ? JSON.stringify(data || '[]')
                  : '[]';

                field.onChange(selectedValue);

                onChangeValue && onChangeValue(selectedValue); // string
                onChangeRawValue && onChangeRawValue(data); // T[] */
              };

              return (
                <Autocomplete
                  ////* checkbox
                  multiple
                  id="checkboxes-tags-demo"
                  limitTags={limitTags}
                  defaultValue={defaultValue}
                  // // options
                  value={value}
                  options={options}
                  loading={isLoadingData}
                  loadingText={loadingText}
                  disableCloseOnSelect
                  // // optional label
                  getOptionLabel={(option: any) => option[valueKey] as any}
                  // // render option checkbox
                  renderOption={(props, option, { selected }) => (
                    <li {...props}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selected}
                      />
                      {option[valueKey] as any}
                    </li>
                  )}
                  getOptionDisabled={_opt => getOptionDisabled}
                  onChange={onChange}
                  disabled={disabled}
                  // // text field
                  renderInput={params => (
                    <TextField
                      {...params}
                      label={label}
                      variant="outlined"
                      error={!!error}
                      helperText={helperText}
                      required={required}
                      disabled={disabled}
                    />
                  )}
                />
              );
            }}
          />
        </FormControl>
      </Grid>
    </>
  );
}
